document.addEventListener(
    'DOMContentLoaded',
    function () {
        // Have to use jQuery here because the gform_post_render event is triggered by Gravity Forms
        // This fires on page load and on submit.
        jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
            // Move validation error message to bottom of form
            jQuery(`#gform_wrapper_${form_id} div.gform_validation_errors`).appendTo(`#gform_${form_id} div.gform_body`)
        })
    },
    false
)

/**
 * Restricts input to numbers only if the field has the class "quantity"
 */
document.addEventListener('input', function (e) {
    const input = e.target
    const gfield = input.closest('.gfield--type-text')

    if (!gfield || !gfield.classList.contains('quantity')) return

    const cursorPos = input.selectionStart
    const originalLength = input.value.length

    // Rensa alla utom siffror
    input.value = input.value.replace(/[^0-9]/g, '')

    // Justera markören om något togs bort
    const newLength = input.value.length
    const diff = originalLength - newLength
    input.setSelectionRange(cursorPos - diff, cursorPos - diff)
})
